import Vue from "vue";
import { getValueByLang } from '@/utils'

// translate router.meta.title, be used in breadcrumb sidebar tagsview
export function generateTitle(title) {
  const hasKey = this.$te('route.' + title)

  if (hasKey) {
    // $t :this method from vue-i18n, inject in @/lang/index.js
    const translatedTitle = this.$t('route.' + title)

    return translatedTitle
  }
  return title
}

// 价格千分位自定义过滤器
Vue.filter('displayi18nValue', function (value, key, lang) {
  return getValueByLang(value, key, lang)
})



// WEBPACK FOOTER //
// ./src/utils/i18n.js